<template>
    <body>
    <form style="max-width:500px;margin:auto">
        <h2>Office</h2>
        <div class="input-container">
            <i class="fa fa-building-o icon"></i>
            <input  size="27" v-model="office.name" class="input-field" maxlength="25" type="text" placeholder="Office Name" name="sname">
            <span style="padding-left: 5px">  Set the Office name (e.g. myPet... )<br>
                <span style="color: yellow;font-style: italic">{{countOChars}} </span> of max 25</span>
        </div>

        <div class="input-container">
            <i class="fa fa-map-marker icon"></i>
            <input v-model="office.location" class="input-field" maxlength="20" type="text" placeholder="Office Location" name="sloc">
            <span style="padding-left: 5px">Set Office Location (e.g. Timisoara )<br>
            <span style="color: yellow;font-style: italic">{{countLChars}} </span> of max 20</span>
        </div>

        <div class="input-container">
            <i class="fa fa-briefcase icon"></i>
            <select v-model="office.type" style="webkit-appearance: menulist-button;">
                <option disabled value="0">Office types</option>
                <option :value="o.type" v-for="o in office_types " :key="o.index">
                    {{o.type}}
                </option>
            </select>
            <span style="padding-left: 5px">Select the Office type </span>
            <span v-if="office_types.length === 0" style="color: orangered;font-size: 15px">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                Empty list, Please add office types...
            </span>
        </div>
        <div class="input-container">
            <label>
                <i class="fa fa-calendar" aria-hidden="true"></i>
                <input type="checkbox" v-model="mdays" name="multidays" v-on:change="multiDaysCalendar">
                <span style="font-size: 12px"> Multi days will set time slot at 24h & disable the office schedule</span>
            </label>
        </div>
        <div class="input-container">
            <i class="fa fa-clock-o icon"></i>
            <input :disabled="offSchedule" v-model="office.slot" class="input-field" type="number" min="10" placeholder="Time slot" name="sbudget">
            <span style="padding-left: 5px">You can set a time slot for each appointment <br> [ minutes ]</span>
        </div>

        <div class="input-container">
            <i class="fa fa-hourglass-start icon"></i>
            <input :disabled="offSchedule" v-model="office.open" class="input-field" type="time" placeholder="The opening Time" name="sdate">
            <span style="padding-left: 5px">Set the opening time of the Office </span>
        </div>
        <div class="input-container" >
            <i class="fa fa-hourglass-end icon"></i>
            <input :disabled="offSchedule" v-model="office.close" class="input-field" type="time" placeholder="The closing Time" name="sdate">
            <span style="padding-left: 5px">Set the closing time of the Office</span>
        </div>

        <button v-if="isNewOffice" class="button-submit" :disabled="offSubmit" @click.prevent="createNewOffice">Create</button>
        <button class="button-submit" :disabled="offSubmit" @click.prevent="updateOffice" v-else> Update</button>
        <button class="button-cancel" @click.prevent="cancelNewOffice">Cancel</button>
    </form>
    <br>
    <div style="font-size: 10px">
        <!--<privacy-policy></privacy-policy> -->
        <i class="fa fa-shield" aria-hidden="true"></i> Privacy Policy :
        The Office data <span style="font-weight: bold">are </span> stored on the server.
    </div>
    </body>
</template>
<script>
    import {getBaseURL} from '../url_endpoints.js'
    import {ulip_post, ulip_put} from '../https_requests.js'
    import {get_office_types_array} from '../office_type_db.js'
    export default {
        name: 'NewSite',
        data() {
            return {
                office: {
                    name: null,
                    location: null,
                    type:null,
                    open: null,
                    close:null,
                    slot:null,
                    bid:null,
                },
                mdays:null,
                baseURL:null,
                office_types: get_office_types_array()
            }
        },
        mounted() {
            this.baseURL = getBaseURL()
            const selected_office = this.$store.getters.getSelectedOffice
            if(!selected_office) {
                //console.log('already a new office')
                this.office.type = 0
            }else {
                if(!selected_office.slot && !selected_office.open && !selected_office.close) {
                    // multi days calendar
                    this.mdays = true
                }
                this.office.name = selected_office.name
                this.office.location = selected_office.location
                this.office.type = selected_office.type
                this.office.open = selected_office.open
                this.office.close = selected_office.close
                this.office.slot = selected_office.slot
                this.office.bid = selected_office.bid
                this.office.id = selected_office.id
            }
        },
        computed: {
            offSchedule() {
                return this.mdays
            },
            countOChars(){
                return !this.office.name ? 0 : this.office.name.length
            },
            countLChars(){
                return !this.office.location ? 0 : this.office.location.length
            },
            offSubmit() {
                if(this.mdays) {
                    if((!this.office.name) || (!this.office.location )) {
                        return true
                    }else {
                        return false
                    }
                }else {
                    if( (!this.office.slot) || (!this.office.name) || (!this.office.location ) || (!this.office.open) || (!this.office.close)) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            isNewOffice() {
                return !this.$store.getters.getSelectedOffice ? true : false
            }
        },
        methods: {
            multiDaysCalendar() {
                // se a null next fields
                this.office.open = null
                this.office.close = null
                this.office.slot = null
            },
            createNewOffice() {
                const business_obj = this.$store.getters.getCurrentBusiness
                if(!business_obj) {
                    //skip post
                    alert('FrontEnd error when trying to post : new office')
                }else {
                    //create resource on the back-end
                    this.office.bid = business_obj.id
                    ulip_post(this.baseURL,'/offices',this.office).then(rsp => {
                        //console.log('New office created: ' , rsp['name'])
                        alert('New Office '+rsp['name']+ ' created!')
                        this.$router.push('/business_offices')
                    }).catch(err => {
                        alert(err + '\nBackend Server could be down! Please try again later..')
                    })
                }
            },
            updateOffice() {
                // update resource on backEnd
                ulip_put(this.baseURL,'/offices',this.office.id,this.office).then( rsp => {
                    alert('Your Office '+ rsp['name'] +' data updated!')
                    this.$router.push('/business_offices')
                }).catch(err => {
                    //console.log(err)
                    alert(err.message + '\nBackend Server could be down! Try again later..')
                })
            },
            cancelNewOffice(){
                this.$router.push('/business_offices')
            }
        }
    }
</script>
<style lang="scss" scoped>
    body{
        height:100vh;
    }
    // using sass features - variable : $variable_name
    $icommentSize: 10px;
    span {
        font-size: 10px//$icommentSize;
    }
    body {
        font-family: Arial, Helvetica, sans-serif;
    }
    * {
        box-sizing: border-box;
    }
    .input-container {
        display: -ms-flexbox; /* IE10 */
        display: flex;
        width: 100%;
        margin-bottom: 15px;
    }
    input[type=number] {
        width: 30%;
    }

    select {
        width:30%;
    }
    .icon {
        padding: 10px;
        background: limegreen;
        color: white;
        //min-width: 50px;
        text-align: center;
    }

    .input-field {
        //width: 100%;
        padding: 10px;
        outline: none;
    }

    .input-field:focus {
        border: 2px solid limegreen;
    }

    /* Set a style for the submit button */
    .btn {
        background-color: limegreen;
        color: white;
        padding: 15px 20px;
        border: none;
        cursor: pointer;
        width: 100%;
        opacity: 0.9;
    }

    .btn:hover {
        opacity: 1;
    }
    // using sass features - inheritance : @extend
    .button-report  {
        @extend .btn;
        background-color: red;
    }

    .button-submit  {
        @extend .btn;
        background-color: lightgreen;
        width: 50%;
        color: black;
    }
    .button-cancel {
        @extend .btn;
        background-color: lightcoral;
        width:50%;
        color: black;
    }
    .button-submit:disabled {
        background-color: #aaaaaa;
    }
    .publish {
        color: darkorange;
    }
    .publish:hover {
        background-color: orangered;
        color: white;
        opacity: 0.9;
    }

    @media screen and (max-width: 600px) {
        .input-container {
            font-size: 10px;
        }
        .input-field {
            padding:0px;
            font-size: 10px;
        }
        span {
            font-size: 8px;
        }
        select {
            font-size: 8px;
        }
    }

</style>